/**
 * Number shown as "Materials: N attached" on an email step before it is generated.
 *
 * The email's own `material_ids` are only the knowledge materials fed to the AI.
 * A deck produced (or a material picked) by an earlier Generate Deck step is
 * attached to the email separately, so it has to be counted too. Otherwise the
 * card reads "0 attached" right after a deck was generated successfully.
 */
export function countAttachedMaterials(
  materialIds: number[] | undefined | null,
  attachedDeck?: { attached_material_id?: number } | null,
): number {
  const ids = new Set(materialIds ?? [])
  const configured = ids.size
  if (!attachedDeck) return configured
  const deckMaterialId = attachedDeck.attached_material_id
  // A picked material that is already in material_ids must not be counted twice.
  if (deckMaterialId !== undefined && ids.has(deckMaterialId)) return configured
  return configured + 1
}
